import React from "react";
import PropTypes from "prop-types";
import { RichText } from "@sitecore-jss/sitecore-jss-react";

const Heading = ({ type, html, typographyClass, className }) => {
  if (!html) {
    return null;
  }
  const changeClass = () => {
    if (typographyClass && typeof document !== "undefined") {
      let node = document.createElement("div");
      node.innerHTML = html.value;
      if (node.firstChild && node.firstChild.className === "") {
        node.firstChild.className = typographyClass;
        html.value = node.innerHTML;
      }
    }
  };
  if (html && html.value) {
    changeClass();
  }
  let typeValue = type && type.fields && type.fields.phrase && type.fields.phrase.value;
  if (typeValue === "h1") {
    return <RichText tag="h1" className={className} field={html} />;
  } else if (typeValue === "h2") {
    return <RichText tag="h2" className={className} field={html} />;
  } else if (typeValue === "h3") {
    return <RichText tag="h3" className={className} field={html} />;
  } else if (typeValue === "h4") {
    return <RichText tag="h4" className={className} field={html} />;
  } else {
    return <RichText tag="span" className={className} field={html} />;
  }
};

Heading.propTypes = {
  type: PropTypes.object,
  className: PropTypes.string,
  html: PropTypes.object
};

export default Heading;
